import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1f2416] text-[#faf7f2]/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-full border border-[#e8c98a]/60 flex items-center justify-center">
              <span className="font-serif italic text-[#e8c98a] text-lg leading-none">Gl</span>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-serif tracking-widest text-sm uppercase text-[#faf7f2]">Genius Loci</span>
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#e8c98a]">Umbria · Casale</span>
            </div>
          </div>
          <p className="text-sm leading-relaxed max-w-md text-[#faf7f2]/60">
            Un casale nel cuore verde d’Italia, dove tradizione, natura e artigianato umbro si incontrano per offrire un’esperienza autentica.
          </p>
        </div>

        <div>
          <h5 className="text-[10px] tracking-[0.3em] uppercase text-[#e8c98a] mb-5">Naviga</h5>
          <ul className="space-y-3 text-sm">
            <li><a href="#about" className="hover:text-[#e8c98a] transition-colors">Il Casale</a></li>
            <li><a href="#gallery" className="hover:text-[#e8c98a] transition-colors">Galleria</a></li>
            <li><a href="#attractions" className="hover:text-[#e8c98a] transition-colors">Territorio</a></li>
            <li><a href="#location" className="hover:text-[#e8c98a] transition-colors">Come raggiungerci</a></li>
          </ul>
        </div>

        <div>
          <h5 className="text-[10px] tracking-[0.3em] uppercase text-[#e8c98a] mb-5">Contatti</h5>
          <ul className="space-y-3 text-sm">
            <li><a href="mailto:info@privateproperties.it" className="hover:text-[#e8c98a] transition-colors">info@privateproperties.it</a></li>
            <li><a href="tel:+393452211974" className="hover:text-[#e8c98a] transition-colors">+39 345 22 11 974</a></li>
            <li className="text-[#faf7f2]/60">Gaglietole, Umbria · Italia</li>
          </ul>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="w-10 h-10 rounded-full border border-[#faf7f2]/20 flex items-center justify-center hover:bg-[#e8c98a] hover:text-[#1f2416] hover:border-[#e8c98a] transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-[#faf7f2]/20 flex items-center justify-center hover:bg-[#e8c98a] hover:text-[#1f2416] hover:border-[#e8c98a] transition-colors">
              <Facebook size={16} />
            </a>
            <a href="mailto:info@privateproperties.it" className="w-10 h-10 rounded-full border border-[#faf7f2]/20 flex items-center justify-center hover:bg-[#e8c98a] hover:text-[#1f2416] hover:border-[#e8c98a] transition-colors">
              <Mail size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#faf7f2]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#faf7f2]/50">
          <p>© {new Date().getFullYear()} Umbria Genius Loci &middot; Property managed by{' '}
            <a href="https://privateproperties.it" target="_blank" rel="noopener noreferrer" className="text-[#e8c98a] hover:text-white transition-colors">
              Private Properties
            </a>
          </p>
          <p className="font-serif italic">“Il luogo ha un’anima. E qui, la puoi ascoltare.”</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
